import React from 'react';

import { AddCircleRounded } from '@material-ui/icons';

import { GameFormatSelector } from './Components/GameFormatSelector/GameFormatSelector';
import { useBoolean } from '../../../common/Hooks/useBoolean.hook';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import { StyledGameFormatSelectorModal } from './GameFormatSelectorModal.Styles';

export const GameFormatSelectorModal = (props: IProps2) => {
  const { clubId, eventId } = props;

  const [openModal, , toggleOpenModal] = useBoolean(false);

  return (
    <StyledGameFormatSelectorModal>
      <Button onClick={toggleOpenModal} id="leaderboards" color="primary" className="button second">
        <AddCircleRounded className="icon override" />
        {'  '}
        ADD GAMES & CONTESTS
      </Button>

      <Modal
        onClose={toggleOpenModal}
        className="teams-creator-modal"
        open={openModal}
        hideCloseButton={true}
        goBackText="Done"
      >
        <GameFormatSelector
          eventId={eventId}
          clubId={clubId}
          afterCreationCallback={toggleOpenModal}
        />
      </Modal>
    </StyledGameFormatSelectorModal>
  );
};
interface IProps2 {
  eventId: string;
  clubId: string;
}
